module.exports = __webpack_public_path__ + "img/match-3.23278606.webp";